module.exports = __webpack_public_path__ + "img/icon-receipt-big-blue.57035863.svg";